import { SelectProps } from 'antd/lib'
import { useMemo } from 'react'

import { useNotificationsServiceGetSenderTypesListEndpoint } from 'src/api/queries'
import { Select } from 'src/components'
import { useDefaultSortingItem } from 'src/hooks'

export const SenderTypeSelect = (props: SelectProps) => {
  const { data, isLoading } =
    useNotificationsServiceGetSenderTypesListEndpoint()
  const { defaultSortingOption } = useDefaultSortingItem()

  const options = useMemo(() => {
    const senderOptions = data?.data?.map((item) => ({
      value: item.id,
      label: item.name
    }))

    return [defaultSortingOption, ...(senderOptions || [])]
  }, [data])

  return <Select loading={isLoading} options={options} {...props} />
}
